import React from "react";
import {useNavigate} from "react-router-dom";
import eventEmitter from "../../shared/eventEmitter";
import {getBusinessOrCustomerName} from "../../shared/sharedFunctions";

interface CustomerCardProps {
    customer: any,
    lastViewedCustomerId?: string | null,
}
const CustomerSearchCard: React.FC<CustomerCardProps> = ({customer, lastViewedCustomerId}) => {
    const navigate = useNavigate();

    const isLastViewed = lastViewedCustomerId != null
        && String(customer.customerId) === String(lastViewedCustomerId);

    const goToDetails = () => {
        sessionStorage.setItem('lastViewedCustomerId', String(customer.customerId));
        eventEmitter.emit('isSidebarOpen', (wasOpen: boolean) => {
            sessionStorage.setItem('sidebarWasOpen', JSON.stringify(wasOpen));
            navigate('/admin/customer-details', {
                state: {
                    customerId: customer.customerId,
                    customerName: customer.customerName,
                    propertyAddress: customer.propertyAddress,
                }
            });
        });
    };

    const goToJob = (jobId: number) => {
        sessionStorage.setItem('lastViewedCustomerId', String(customer.customerId));
        eventEmitter.emit('isSidebarOpen', (wasOpen: boolean) => {
            sessionStorage.setItem('sidebarWasOpen', JSON.stringify(wasOpen));
            navigate(`/admin/job-details`, {
                state: {
                    jobId: jobId,
                    customerId: customer.customerId,
                    customerName: customer.customerName,
                    propertyAddress: customer.propertyAddress,
                    homePhone: customer.homePhone,
                }
            });
        });
    };

    function getAmountToShow(job) {
        if(job.jobStatus === 'GOEST')
            return ''
        if(job.jobStatus === 'DRIVEBY')
            return job.estimateAmount
        return job.amountCharged
    }

    
    return (
        <div className={isLastViewed ? "resultCard resultCard--last-viewed" : "resultCard"}>
            <div className="mainInfo" onClick={goToDetails} style={{cursor: "pointer",}}>
                <div className="customerName">
                    <a className="">
                        {/*J <span className="searchHighlight">Morrison</span>*/}
                        {customer.customerName}
                    </a>
                </div>
                <span className="propertyAddress">
                                            {customer.propertyAddress}
                                </span>
            </div>
            {customer.jobs.map(job => {
                return (
                    <React.Fragment key={job.jobId}>
                        <div style={{cursor: 'pointer'}} className="jobInfo" onClick={() => goToJob(job.jobId)}>
                            <div className="row">
                                <div className="col mb-3 mb-lg-0">
                                    <div className="infoBlock">
                                        <span className="infoLabel">Job Date</span>
                                        <span className="infoData">{job.dateDone}</span>
                                    </div>
                                </div>
                                <div className="col mb-3 mb-lg-0">
                                    <div className="infoBlock">
                                        <span className="infoLabel">Amount</span>
                                        <span className="infoData">{getAmountToShow(job)}</span>
                                    </div>
                                </div>
                                <div className="col mb-3 mb-lg-0">
                                    <div className="infoBlock">
                                        <span className="infoLabel">Status</span>
                                        <span className="infoData">
                                            {customer?.customerStatusId !== 1 ? customer.customerStatus : job.jobStatus}
                                        </span>
                                    </div>
                                </div>
                                <div className="col mb-3 mb-lg-0">
                                    <div className="infoBlock">
                                        <span className="infoLabel">Truck #</span>
                                        <span className="infoData">{job.truckNumber ?? "N/A"}</span>
                                    </div>
                                </div>
                                <div className="col mb-3 mb-lg-0">
                                    <div className="infoBlock">
                                        <span className="infoLabel">Arrival Time</span>
                                        <span className="infoData">{job.arrivalTime ? new Date(job.arrivalTime).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' }) : "N/A"}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
}

export default CustomerSearchCard;